/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner } from './PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner';
import {
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerFromJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerFromJSONTyped,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerToJSON,
    PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerToJSONTyped,
} from './PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner';

/**
 * 
 * @export
 * @interface PatchOrganizationCombosRequestInnerAllOfCategoriesInner
 */
export interface PatchOrganizationCombosRequestInnerAllOfCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    comboId: string;
    /**
     * 
     * @type {string}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    min?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    selectedByDefault?: boolean | null;
    /**
     * 
     * @type {Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner>}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    products: Array<PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInner>;
    /**
     * 
     * @type {number}
     * @memberof PatchOrganizationCombosRequestInnerAllOfCategoriesInner
     */
    position: number;
}

/**
 * Check if a given object implements the PatchOrganizationCombosRequestInnerAllOfCategoriesInner interface.
 */
export function instanceOfPatchOrganizationCombosRequestInnerAllOfCategoriesInner(value: object): value is PatchOrganizationCombosRequestInnerAllOfCategoriesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('comboId' in value) || value['comboId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSON(json: any): PatchOrganizationCombosRequestInnerAllOfCategoriesInner {
    return PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchOrganizationCombosRequestInnerAllOfCategoriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comboId': json['comboId'],
        'name': json['name'],
        'enabled': json['enabled'],
        'max': json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'selectedByDefault': json['selectedByDefault'] == null ? undefined : json['selectedByDefault'],
        'products': ((json['products'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerFromJSON)),
        'position': json['position'],
    };
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSON(json: any): PatchOrganizationCombosRequestInnerAllOfCategoriesInner {
    return PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSONTyped(json, false);
}

export function PatchOrganizationCombosRequestInnerAllOfCategoriesInnerToJSONTyped(value?: PatchOrganizationCombosRequestInnerAllOfCategoriesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'comboId': value['comboId'],
        'name': value['name'],
        'enabled': value['enabled'],
        'max': value['max'],
        'min': value['min'],
        'selectedByDefault': value['selectedByDefault'],
        'products': ((value['products'] as Array<any>).map(PatchOrganizationCombosRequestInnerAllOfCategoriesInnerProductsInnerToJSON)),
        'position': value['position'],
    };
}

